import * as React from "react";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "../hooks";
import { isRequired } from "../hooks/useForm";
import {  PosizionamentoContext } from "../contexts";
import { useContext } from "react";
import { Search } from "@mui/icons-material";
import {  
  Alert,
  Grid,
  IconButton,
  InputAdornment,

} from "@mui/material";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";



const InfoBarcode = () => {
  const inputRef = React.useRef();
  const { codiceMenu } = useParams();
  

  const {
      state:{infoBarcode}, 
      getInfoBarcodeCustom   
  } = useContext(PosizionamentoContext);

  const validations = [
    ({ code }) => isRequired(code) || { code: "*Barcode obbligatorio" },
  ];
  React.useEffect(() => {
    setTimeout(() => {
      inputRef.current.focus();
    }, 100);
    
  }, []);

  const {
    values: barcodeForm,
    changeHandler,
    touched,
    errors,
    isValid,
  } = useForm(
    {
      code: "",
    },
    validations
  );

  const onkeyEnter = (event) => {
    if (event === 13) {
      inputRef.current.blur();
      if (barcodeForm.code && isValid) {
        //getPartenzaTrazione(barcodeForm.code, navigate);
        getInfoBarcodeCustom(barcodeForm.code, clearForm);
      }
    }
  };

  const clearForm = () => {
    barcodeForm.code = "";
      setTimeout(() => {
    inputRef.current && inputRef.current.focus();
    }, 100);
  }
  
  
  return (
    <>

      <Stack direction={"row"} spacing={2} m={2}>

        <TextField
          id="outlined-basic"
          label="Barcode"
          variant="outlined"
          placeholder="Inserire il barcode"
          fullWidth
          autoFocus
          autoComplete="off"
          inputRef={inputRef}
          /* onClick={()=> inputRef.current.blur()}
              onDoubleClick={()=> inputRef.current.focus()} */
          onKeyPress={(e) => onkeyEnter(e.charCode)}
          onChange={(e) => changeHandler("code", e.target.value)}
          error={Boolean(touched.code && errors.code)}
          //helperText={touched.code && errors.code}
          value={barcodeForm.code || ""}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton color="primary" disabled={!isValid}  onClick={()=>{      if (barcodeForm.code && isValid) {
        //getPartenzaTrazione(barcodeForm.code, navigate);
        getInfoBarcodeCustom(barcodeForm.code);
      }}}>
                  <Search />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
    </Stack> 

    

    {infoBarcode? (
      <Grid item xs={12} md={12} lg={12}>
        <Alert severity="warning" icon={<></>}>
        {
          <ReactMarkdown
            children={infoBarcode ? infoBarcode : ""}
            rehypePlugins={[rehypeRaw]}
          ></ReactMarkdown>
              }{" "}
            </Alert>
          </Grid>
        ) : (
          <></>
        )}       

    </>
  );
};
export default InfoBarcode;